module.exports = __webpack_public_path__ + "img/40_37_014_450.126540df.jpg";